import React, { useLayoutEffect, useRef } from 'react';
import { TextArea, TextAreaProps } from 'edozvola-frontend-lib/dist/ui';

interface AutosizeTextareaProps {
  minRows?: number;
}

export const AutosizeTextArea = ({ minRows, ...props }: AutosizeTextareaProps & TextAreaProps) => {
  const DEFAULT_FIELD_HEIGHT = 34;
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'inherit';
      textareaRef.current.style.height = `${Math.max(
        textareaRef.current.scrollHeight,
        minRows ? minRows * DEFAULT_FIELD_HEIGHT : DEFAULT_FIELD_HEIGHT,
      )}px`;
    }
  }, [props.value]);

  return <TextArea innerRef={textareaRef} {...props} />;
};
